<p-confirmDialog key="idpmodify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid2Col">
	<label>Code/Abbreviation:</label>
	<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="IdentityProviderCD" placeholder="Ex. Google" />

	<label>Description:</label>
	<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="IdentityProviderDesc" placeholder="Ex. Google" />

	<label>Login Button Text:</label>
	<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="LoginButtonDesc" placeholder="Ex. Login with Google" />

	<label>Button Background Color:</label>
	<p-colorPicker [disabled]="IsLoading() == true" [(ngModel)]="LoginButtonBackground"></p-colorPicker>

	<label>Button Text Color:</label>
	<p-colorPicker [disabled]="IsLoading() == true" [(ngModel)]="LoginButtonForeground"></p-colorPicker>

	<label>Button Icon (Link):</label>
	<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="LoginButtonIconLink" />

	<label>Login Link:</label>
	<div class="InfoDiv">
		<input
			[disabled]="IsLoading() == true"
			type="text"
			class="form-control"
			[(ngModel)]="LoginButtonLink"
			placeholder="Ex. http://sso.access411.com/GoogleLogin"
		/>
		<p class="WarningText">Note: This link should go to the CAASS.SSO Api Endpoint (not the IDP itself Ex. Google, Okta, Etc.)</p>
	</div>

	<label>Logout Link:</label>
	<div class="InfoDiv">
		<input
			[disabled]="IsLoading() == true"
			type="text"
			class="form-control"
			[(ngModel)]="LogoutButtonLink"
			placeholder="Ex. http://sso.access411.com/GoogleLogout"
		/>
		<p class="WarningText">Note: This link should go to the CAASS.SSO Api Endpoint (not the IDP itself Ex. Google, Okta, Etc.)</p>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onSave()">{{ EditMode == false ? "Add IDP" : "Update IDP" }}</button>
	<button [disabled]="Processing == true" class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
